// extracted by mini-css-extract-plugin
module.exports = {"burgerBox":"BurgerButton_burgerBox__4yaP0"};